import { CommonModule, DecimalPipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { AngularSvgIconModule } from 'angular-svg-icon'
import { DateRangeInputComponent } from './components/date-range-input/date-range-input.component'
import { DatetimeInputComponent } from './components/datetime-input/datetime-input.component'
import { DatetimeRangeInputComponent } from './components/datetime-range-input/datetime-range-input.component'
import { DrawerComponent } from './components/drawer/drawer.component'
import { ChoiceDialogModalComponent } from './components/modals/choice-dialog-modal/choice-dialog-modal.component'
import { ConfirmDialogModalComponent } from './components/modals/confirm-dialog-modal/confirm-dialog-modal.component'
import { InputDialogModalComponent } from './components/modals/input-dialog-modal/input-dialog-modal.component'
import { AutoSelectDirective } from './directives/auto-select.directive'
import { AppLocaleScopeTimezoneDatePipe } from './pipes/app-locale-scope-timezone-date/app-locale-scope-timezone-date.pipe'
import { FirstErrorPipe } from './pipes/first-error/first-error.pipe'
import { PureFilterPipe } from './pipes/pure-filter/pure-filter.pipe'
import { PureSortPipe } from './pipes/pure-sort/pure-sort.pipe'
import { NgbVendorModule } from './vendors/ngb.vendor.module'
import { AppLocaleDatePipe } from './pipes/app-locale-date/app-locale-date.pipe'
import { AppLocaleDurationPipe } from './pipes/app-locale-duration/app-locale-duration.pipe'
import { NumberOrNaNPipe } from './pipes/number-or-nan/number-or-nan.pipe'

const vendorModules = [
  NgbVendorModule,
]

const publicComponents = [
  AutoSelectDirective,
  DrawerComponent,
  FirstErrorPipe,
  PureFilterPipe,
  PureSortPipe,
  AppLocaleScopeTimezoneDatePipe,
  AppLocaleDatePipe,
  AppLocaleDurationPipe,
  NumberOrNaNPipe,
  // date & time input components
  DateRangeInputComponent,
  DatetimeInputComponent,
  DatetimeRangeInputComponent,
]
const modalComponents = [
  ChoiceDialogModalComponent,
  ConfirmDialogModalComponent,
  InputDialogModalComponent,
]
@NgModule({
  declarations: [
    ...publicComponents,
    ...modalComponents,
  ],
  providers: [
    AppLocaleScopeTimezoneDatePipe,
    AppLocaleDatePipe,
    AppLocaleDurationPipe,
    DecimalPipe,
    NumberOrNaNPipe,
  ],
  bootstrap: [],
  imports  : [
    ...vendorModules,
    NgbModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    AngularSvgIconModule,
  ],
  exports: [
    ...vendorModules,
    ...publicComponents,
    ...modalComponents,
    AngularSvgIconModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class SharedModule { }
